var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.268,
    height: 32,
    viewBox: "0 0 28.268 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path144",
    d: "M0-682.665H28.268v32H0Z",
    transform: "translate(0 682.665)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile-icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g148",
    transform: "translate(5.797 0.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path150",
    d: "M-328.477-612.54h-11.7a2.664,2.664,0,0,1-2.485-2.812v-24.5a2.664,2.664,0,0,1,2.485-2.812h11.7a2.664,2.664,0,0,1,2.485,2.813v24.5A2.664,2.664,0,0,1-328.477-612.54Z",
    transform: "translate(342.666 642.665)",
    fill: "none",
    stroke: "#09c",
    strokeWidth: 2.33
  })), /*#__PURE__*/React.createElement("g", {
    id: "g152",
    transform: "translate(5.797 27.313)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path154",
    d: "M0,0H16.674",
    fill: "none",
    stroke: "#09c",
    strokeWidth: 2.33
  })), /*#__PURE__*/React.createElement("g", {
    id: "g156",
    transform: "translate(9.11 0.937)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M-232.618,0l-1.656,3.75h-6.736L-242.666,0",
    transform: "translate(242.666)",
    fill: "none",
    stroke: "#09c",
    strokeWidth: 2.33
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.e273707d276b0ac9f804d6e8459e6479.svg";
export { ForwardRef as ReactComponent };